// toggle-rich-text.js
function initToggleRichText(root) {
  const scope = root || document;
  const containers = scope.querySelectorAll(
    '.mobile-toggle-text-container:not([data-processed])'
  );

  containers.forEach(container => {
    try {
      // ✅ Respecte les réglages mobile/desktop du Liquid
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      const collapseEnabled = isMobile
        ? container.dataset.mobileCollapse === 'true'
        : container.dataset.desktopCollapse === 'true';

      const limit = isMobile
        ? (parseInt(container.dataset.mobileTruncate, 10) || 200)
        : (parseInt(container.dataset.desktopTruncate, 10) || 800);

      if (!collapseEnabled) {
        container.setAttribute('data-processed', '1');
        return;
      }

      // Grab original HTML and children
      const originalHTML = container.innerHTML;
      const children = Array.from(container.children);

      // ✅ Texte brut robuste (fonctionne même si <p> sont imbriqués)
      const fullPlainText = (container.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

      // If nothing to truncate, leave as-is
      if (!fullPlainText || fullPlainText.length <= limit) {
        container.setAttribute('data-processed', '1');
        return;
      }


      // Build details/toggle + full content
      const details = document.createElement('details');
      details.className = 'rc-details';

      const summary = document.createElement('summary');
      summary.className = 'rc-toggle';
      summary.innerHTML =
        '<span class="rc-more">Voir plus</span><span class="rc-less">Voir moins</span>';

      const fullWrap = document.createElement('div');
      fullWrap.className = 'rte rc-full';
      fullWrap.innerHTML = originalHTML;

      // Build short content (clone non-<p> elems like H2/H4/etc + truncated p)
      const shortWrap = document.createElement('div');
      shortWrap.className = 'rte rc-short';

      // Garder le premier H2 (si présent) puis le premier H3 (si présent)
      const firstH2 = container.querySelector('h2');
      if (firstH2) shortWrap.appendChild(firstH2.cloneNode(true));

      const firstH3 = container.querySelector('h3');
      if (firstH3) shortWrap.appendChild(firstH3.cloneNode(true));

      // Si aucun H2/H3, fallback sur le premier titre trouvé
      if (!firstH2 && !firstH3) {
        const firstTitle = container.querySelector('h1,h2,h3,h4,h5,h6');
        if (firstTitle) shortWrap.appendChild(firstTitle.cloneNode(true));
      }

      // Construire un "short" en conservant les paragraphes
      const ps = Array.from(container.querySelectorAll('p'));
      let remaining = limit;

      ps.some(p => {
        const text = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return false;

        if (text.length <= remaining) {
          const el = document.createElement('p');
          el.textContent = text;
          shortWrap.appendChild(el);
          remaining -= text.length;
          return false;
        }

        const el = document.createElement('p');
        el.textContent = text.slice(0, remaining).trim() + '…';
        shortWrap.appendChild(el);
        return true;
      });


      // Rebuild container
      container.innerHTML = '';
      // Order will be set by CSS; we append both
      container.appendChild(shortWrap);
      container.appendChild(details);
      details.appendChild(summary);
      details.appendChild(fullWrap);

      // JS fallback to hide/show short when opening details
      details.addEventListener('toggle', () => {
        shortWrap.style.display = details.open ? 'none' : '';
      });

      container.setAttribute('data-processed', '1');
    } catch (e) {
      // Fail-safe: if something goes wrong, keep original content
      console.error('toggle-rich-text error:', e);
    }
  });
}

// 1) Chargement normal de la page
document.addEventListener('DOMContentLoaded', function () {
  initToggleRichText(document);
});

// 2) Quand Shopify recharge une section (éditeur de thème)
document.addEventListener('shopify:section:load', function (e) {
  const root = e.target || document;

  // Autoriser un nouveau calcul
  root
    .querySelectorAll('.mobile-toggle-text-container[data-processed]')
    .forEach(el => el.removeAttribute('data-processed'));

  // Relancer l'init sur la section rechargée
  initToggleRichText(root);
});

// Re-init when Shopify theme editor updates the section
document.addEventListener('shopify:section:load', function () {
  document
    .querySelectorAll('.mobile-toggle-text-container[data-processed]')
    .forEach(el => el.removeAttribute('data-processed'));
});
